import React, { useState, useEffect } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { useParams } from 'react-router-dom'
import { fetchApp } from '../../store/actions/appAction'
import { useTheme } from '@mui/material/styles';
import OutlinedInput from '@mui/material/OutlinedInput';
import MenuItem from '@mui/material/MenuItem';
import Select from '@mui/material/Select';

import { makeStyles } from '@material-ui/core/styles';
// import env from "../../env"
import { Typography, Grid, InputLabel, FormControl, NativeSelect } from '@material-ui/core';

const useStyles = makeStyles((theme) => ({
  channel: {
    fontSize: '22px',
    color: 'black',
    fontWeight: '500'
  },
  selectChannel: {
    marginTop: '.2rem !important',
    
    "& .MuiSelect-select": {
      maxWidth: "130px",
      paddingTop: '5px',
      paddingBottom: '5px'
    },

    "& .MuiPaper-root": {
      maxHeight: '250px'
    },

    [theme.breakpoints.down("sm")]: {
      marginBottom: '20px'
    },
  },
}));

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 5 + ITEM_PADDING_TOP,
    },
  },
};

const categories = [
  'Google',
  'Facebook',
  'LinkedIn',
  'SMS OTP',
  'Whatsapp OTP',
];

function getStyles(name, categoryName, theme) {
  return {
    fontWeight:
      categoryName.indexOf(name) === -1
        ? theme.typography.fontWeightRegular
        : theme.typography.fontWeightMedium,
  };
}


const ReportSummary = ({ overalStats, categorySelected }) => {
    const dispatch = useDispatch()
    const classes = useStyles();
    const {id} = useParams()
    const theme = useTheme();
    const [categoryName, setCategoryName] = useState([]);

    useEffect(() => {
      dispatch(fetchApp(id))
    }, [dispatch, id])

    const app = useSelector(state => state.appReducer.app)
    
    useEffect(() => {
      categorySelected(categoryName)
    }, [categoryName])

    const handleChange = (event) => {
      const {
        target: { value },
      } = event;
      setCategoryName(
        // On autofill we get a the stringified value.
        typeof value === 'string' ? value.split(',') : value,
      );
    };
  

    return (
        <div>
          <Grid container className={classes.contentReport}>
            <Grid item xs={12} md>
                <InputLabel variant="standard" htmlFor="uncontrolled-native" className={classes.channel}>
                  Channel
                </InputLabel>
              <FormControl sx={{ m: 1, width: 300, mt: 3 }}>
                <Select
                  className={classes.selectChannel}
                  multiple
                  displayEmpty
                  value={categoryName}
                  onChange={handleChange}
                  input={<OutlinedInput />}
                  renderValue={(selected) => {
                    if (selected.length === 0) {
                      return <em>All Channel</em>;
                    }

                    return selected.join(', ');
                  }}
                  MenuProps={MenuProps}
                  inputProps={{ 'aria-label': 'Without label' }}
                >
                  <MenuItem disabled value="">
                    <em>All Channel</em>
                  </MenuItem>
                  {categories.map((category) => (
                    <MenuItem
                      key={category}
                      value={category}
                      style={getStyles(category, categoryName, theme)}
                    >
                      {category}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid>
            
            <Grid item xs={12} md className="text-center">
              <Typography className="font-size-16 reguler">Total User Login</Typography>
              <Typography className="font-size-24 bold">
                {
                  overalStats? overalStats.totalSignIn : 0
                }
              </Typography>
            </Grid>
            
            <Grid item xs={12} md className="text-center">
              <Typography className="font-size-16 reguler">Total Login Berhasil</Typography>
              <Typography className="font-size-24 bold text-green">
                {
                  overalStats? overalStats.totalSuccessSignIn : 0
                }
              </Typography>
            </Grid>            
            <Grid item xs={12} md className="text-center">
              <Typography className="font-size-16 reguler">Total Login Gagal</Typography>
              <Typography className="font-size-24 bold text-red">
                {
                  overalStats? overalStats.totalFailedSignIn : 0
                }
              </Typography>
            </Grid>

            <Grid item xs={12} md className="text-center">
              <Typography className="font-size-16 reguler">Kuota</Typography>
              <Typography className="font-size-24 bold">600</Typography>
            </Grid>
          </Grid>
          <br/>
        </div>
    )
}

export default ReportSummary
